// Every component interpretes the size by itsellf.
// E.g. the ImageSelector defines with this size the size of the images
// with defining the number of columns depending on the size.
export enum ComponentSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}
